var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgRegistrationSuccess = function SvgRegistrationSuccess(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 96,
    height: 96,
    fill: "none"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#registrationSuccess_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FFD828",
    d: "M57.618 37.626c-12.076-12.038-25.07-18.59-29.05-14.628a3.3 3.3 0 0 0-.416.505v.031a4.1 4.1 0 0 0-.556 1.292L.795 86.894A6 6 0 0 0 0 89.905a6.1 6.1 0 0 0 .766 2.937 6.128 6.128 0 0 0 7.978 2.549l62.571-28.124c.367-.17.702-.4.99-.682 3.97-3.95-2.598-16.908-14.687-28.959"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFE56A",
    d: "M1.773 94.172a6.8 6.8 0 0 1-1.718-5.096l33.576-50.98 11.617 14.019z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#AD8924",
    d: "M66.493 66.287c2.448-2.44-4.062-12.885-14.54-23.33S30.996 26.022 28.548 28.462c-2.447 2.44 4.063 12.885 14.541 23.33s20.957 16.934 23.404 14.495"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "red",
    d: "M11.006 33.219a3.663 3.663 0 0 0 3.669-3.658 3.663 3.663 0 0 0-3.669-3.657 3.663 3.663 0 0 0-3.669 3.657 3.663 3.663 0 0 0 3.67 3.658M75.822 32.61a3.663 3.663 0 0 0 3.668-3.658 3.663 3.663 0 0 0-3.668-3.657 3.663 3.663 0 0 0-3.67 3.657 3.663 3.663 0 0 0 3.67 3.657"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFD828",
    d: "M75.822 86.248a3.05 3.05 0 0 0 3.057-3.048 3.053 3.053 0 0 0-3.058-3.048 3.053 3.053 0 0 0-3.057 3.048 3.05 3.05 0 0 0 3.058 3.048"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF6CA",
    d: "M25.987 68.571c1.182 0 2.14-.955 2.14-2.133a2.137 2.137 0 0 0-2.14-2.133c-1.182 0-2.14.955-2.14 2.133s.958 2.133 2.14 2.133"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFD828",
    d: "M92.943 42.971A3.05 3.05 0 0 0 96 39.924a3.05 3.05 0 0 0-3.057-3.048 3.05 3.05 0 0 0-3.058 3.048 3.05 3.05 0 0 0 3.058 3.047"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00CDFF",
    d: "M81.325 13.105a2.44 2.44 0 0 0 2.446-2.438 2.44 2.44 0 0 0-2.446-2.438 2.44 2.44 0 0 0-2.446 2.438 2.44 2.44 0 0 0 2.446 2.438M6.726 5.18a2.44 2.44 0 0 0 2.446-2.437A2.44 2.44 0 0 0 6.726.305 2.44 2.44 0 0 0 4.28 2.743 2.44 2.44 0 0 0 6.726 5.18"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#00CDFF",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 4,
    d: "M34.854 2.134s15.286 7.314 3.668 25.6"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "red",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 4,
    d: "M86.675 55.43s-9.594-13.94-25.944.305"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#9500E7",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 4,
    d: "M60.84 7.924s4.28.61 4.28 4.876c0 4.267-4.89 4.876-7.948 4.267-3.057-.61-4.28 2.438-4.28 3.657s1.834 4.267 4.891 4.876a6.54 6.54 0 0 1 2.902 1.222 6.5 6.5 0 0 1 1.99 2.435c.611 1.22 0 4.876-3.669 3.657s-6.726 1.22-6.726 1.22-3.057 2.437-.611 5.485 4.28 2.438 4.28 2.438"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "red",
    d: "M40.968 86.247c2.364 0 4.28-1.91 4.28-4.266a4.273 4.273 0 0 0-4.28-4.267 4.273 4.273 0 0 0-4.28 4.267 4.273 4.273 0 0 0 4.28 4.266"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "registrationSuccess_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h96v96H0z"
  })))));
};
export { SvgRegistrationSuccess as ReactComponent };
export default __webpack_public_path__ + "542f17a2847571595aee75ed0e02f915.svg";